import { TRIAL_DAYS } from '@/config';
import { TAX_PAYER_TYPE } from '@/store/profile';

const vatCountries = {
	at: 20, // Austria
	be: 21, // Bélgica
	bg: 20, // Bulgaria
	cy: 19, // Chipre
	cz: 21, // Chequia
	de: 19, // Alemania
	dk: 25, // Dinamarca
	ee: 22, // Estonia
	el: 24, // Grecia
	gr: 24, // Grecia
	es: 21, // España
	fi: 24, // Finlandia
	fr: 20, // Francia
	hr: 25, // Croacia
	hu: 27, // Hungría
	ie: 23, // Irlanda
	it: 22, // Italia
	lt: 21, // Lituania
	lu: 17, // Luxemburgo
	lv: 21, // Letonia
	mt: 18, // Malta
	nl: 21, // Países Bajos
	pl: 23, // Polonia
	pt: 23, // Portugal
	ro: 19, // Rumanía
	se: 25, // Suecia
	si: 22, // Eslovenia
	sk: 20 // Eslovaquia
};

export function getVatValues(
	price,
	{ country, accountType, priceKey = 'baseAmount' } = {}
) {
	let vatValue = 0;
	let vatPercent = 0;

	if (!price[priceKey]) {
		return {
			vatValue,
			vatPercent
		};
	}

	const isFromEU = vatCountries[country];
	const isPrivate = accountType === TAX_PAYER_TYPE.PRIVATE;
	const isSpain = country === 'es';

	if (isSpain || (isFromEU && isPrivate)) {
		vatPercent = vatCountries[country];
		const vatDivider = 1 + vatPercent / 100;

		const priceWithoutVat = price[priceKey] / vatDivider;

		vatValue = Math.round((vatPercent * priceWithoutVat) / 100);
	}

	return {
		vatValue,
		vatPercent
	};
}

export function getPlanCheckoutName(planName, t, i18n) {
	return i18n.exists(`plans.${planName}.checkoutName`)
		? t(`plans.${planName}.checkoutName`, { trialDays: TRIAL_DAYS })
		: t(`plans.${planName}.name`, { trialDays: TRIAL_DAYS });
}
